import { faAngleLeft, faFileLines, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useLayoutEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import "../Projects/Projects.css";
import "./HighTensionProjects.css";
import "../Categories/Categories.css";
import Header from "../../Components/Header/Header";
import TestingSessions from "../TestingSessions/TestingSessions";
import HTLearningSessions from "../HTLearningSessions/HTLearningSessions";
import HTTrainingSessions from "../HTTrainingSessions/HTTrainingSessions";
import CreateTrainingSessionForm from "../CreateTrainingSession/CreateTrainingSessionForm";
import CreateLearningSessionForm from "../CreateLearningSession/CreateLearningSessionForm";

const HighTensionProjects = ({ data, socket } : { data: any, socket: any }) => {
    

    const navigate = useNavigate();
    const [category, setCategory] = useState("projects");
    const location = useLocation();
    const { module } = useParams();
    const [cookies, setCookie] = useCookies();
    const [activeOption, setActiveOption] = useState<number>(module === "learning" ? 1 : module === "training" ? 2 : module === "testing" ? 3 : (location?.state?.activeOption || 1));
    const [debugViewOption, setDebugViewOption] = useState<number>(location?.state?.testingViewOption ?? 0);
    
    useEffect(() => {
        document.body.classList.remove("grid-body");
        document.querySelector("html")?.classList.remove("grid-body");

    }, [location]);

    useEffect(() => {
        if (activeOption === location?.state?.activeOption) return;
        navigate(`/high-tension/${module}`, { state: { activeOption: activeOption }, replace: true });
    }, [activeOption]);

    useLayoutEffect(() => {
        if (debugViewOption === location?.state?.testingViewOption) return;
        navigate(`/high-tension/${module}`, { state: { activeOption: activeOption, testingViewOption: debugViewOption }, replace: true });
    }, [debugViewOption]);

    useEffect(() => {
        
    }, []);

    const removeSession = async (projectId : string, e : any) => {
        
        const options = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        };

        try {
            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/project/remove-project/${data.userData.userId}/${projectId}`, options);
            const response = await request.json();
            if (response.success) window.location.reload();
            else console.log(response);
        } catch (e) {
        }
    };

    return (
        <div className="content categories-content project-content">

            <Header data={data} socket={socket} />

            {/* Which module the session screens below belong to. */}
            <div className="module-title-container">
                <h2 className="title-module">{cookies?.language === "en"
                    ? (module === "learning" ? "Learning Module" : module === "training" ? "Training Module" : module === "testing" ? "Testing Module" : "")
                    : (module === "learning" ? "Modul Învățare" : module === "training" ? "Modul Antrenare" : module === "testing" ? "Modul Testare" : "")}</h2>
            </div>

            {/* <div className="switch-options squared">

                <div className={`switch-option ${activeOption === 1 ? "active" : ""}`} onClick={() => {
                    setActiveOption(1);
                    setDebugViewOption(0);
                }}>
                    <p>{cookies?.language === "en" ? "Learning" : "Învățare"}</p>
                </div>

                <div className={`switch-option ${activeOption === 2 ? "active" : ""}`} onClick={() => {
                    setActiveOption(2);
                    setDebugViewOption(0);
                }}>
                    <p>{cookies?.language === "en" ? "Training" : "Antrenare"}</p>
                </div>

                <div className={`switch-option ${activeOption === 3 ? "active" : ""}`} onClick={() => {
                    setActiveOption(3);
                    setDebugViewOption(0);
                }}>
                    <p>{cookies?.language === "en" ? "Testing" : "Testare"}</p>
                </div> 
            </div> */}

            <div className="go-back" onClick={() => navigate(`/categories`)}>
                <FontAwesomeIcon icon={faAngleLeft} className="back-icon" />
            </div>

            {activeOption === 3 || activeOption === 1 || activeOption === 2 ? (
                <div className="switch-options">

                    {data.userData.type === "teacher" || activeOption === 1 || activeOption === 2 ? <div className={`switch-option ${debugViewOption === 0 ? "active" : ""}`} onClick={() => setDebugViewOption(0)}>
                        <p>{cookies?.language === "en" ? "Create Session" : "Creează Sesiune"}</p>
                    </div> : null}
                    
                    <div className={`switch-option ${debugViewOption === 1 ? "active" : ""}`} onClick={() => setDebugViewOption(1)}>
                        <p>{cookies?.language === "en" ? "Ongoing Sessions " : "Sesiuni în derulare"}</p>
                    </div>

                    <div className={`switch-option ${debugViewOption === 2 ? "active" : ""}`} onClick={() => setDebugViewOption(2)}>
                        <p>{cookies?.language === "en" ? "Finished Sessions" : "Sesiuni Finalizate"}</p>
                    </div>
                    
                </div>
            ) : null}
            
            {activeOption === 3 && debugViewOption === 0 ? <h2 className="title">{cookies?.language === "en" ? "Choose scenario" : "Alege scenariu"}</h2> : null}
            
            {/* "Învățare": same session flow as "Antrenare", but the run is dictated
                step by step (order -> spoken read-back -> execution on the scheme). */}
            {activeOption === 1 && debugViewOption === 0 ? <CreateLearningSessionForm data={data} /> : null}
            {activeOption === 1 && debugViewOption === 1 ? <HTLearningSessions data={data} finished={false} /> : null}
            {activeOption === 1 && debugViewOption === 2 ? <HTLearningSessions data={data} finished={true} /> : null}

            {activeOption === 2 && debugViewOption === 1 ? <HTTrainingSessions data={data} finished={false} /> : null}
            {activeOption === 2 && debugViewOption === 2 ? <HTTrainingSessions data={data} finished={true} /> : null}

            {activeOption === 2 && debugViewOption === 0 ? <>
                    <CreateTrainingSessionForm data={data} />
            </> : activeOption === 3 && debugViewOption === 0 && data.userData.type === "teacher" ? (
                <div className="projects-container high-tension">
                    <div className="project-gradient" onClick={(e : any) => navigate(`/options-testing/1`, { state: { scenario: "shock" } })}>
                        <div className="project test">
                            <h2>{cookies.language === "en" ? "Electrocution colleague" : "Electrocutare coleg"}</h2>

                            {/* <div className="format">
                                <FontAwesomeIcon icon={faFileLines} className="format-icon" />
                                <p>A4</p>
                            </div> */}


                        </div>

                        
                    </div>

                    <div className="project-gradient" onClick={(e : any) => navigate(`/options-testing/1`, { state: { scenario: "fire" } })}>
                        <div className="project test">
                            <h2>{cookies.language === "en" ? "Fire" : "Incendiu"}</h2>

                            {/* 
                            <div className="format">
                                <FontAwesomeIcon icon={faFileLines} className="format-icon" />
                                <p>A4</p>
                            </div> */}


                        </div>
                    </div>
                </div>
            ) : debugViewOption === 1 && activeOption === 3 ? (
                <TestingSessions data={data} socket={socket} finished={false} key={0} />
            ) : debugViewOption === 2 && activeOption === 3 ? (
                <TestingSessions data={data} socket={socket} finished={true} key={1} />
            ) : null}

            {/* Docked to the bottom of the viewport: who is signed in. */}
            <div className="name-container">
                <div className="name">
                    <FontAwesomeIcon icon={faUser} className="user-icon" />
                    <p>{data.userData.username} {data.userData.type === "teacher" ? (cookies?.language === "en" ? "(Teacher)" : "(Profesor)") : (cookies?.language === "en" ? "(Student)" : "(Elev)")}</p>
                </div>
            </div>
        </div>
    );
};

export default HighTensionProjects;